import gql from 'graphql-tag';

const SPLIT_NOTIFY_SHUTDOWN = gql`
    mutation splitNotifyShutdown($salesChannelId: String) {
        splitNotifyShutdown(salesChannelId: $salesChannelId) {
            internalCode
            message
        }
    }
`;

export default SPLIT_NOTIFY_SHUTDOWN;
